import {Component} from '@angular/core';
import {NbCardModule} from "@nebular/theme";

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  imports: [
    NbCardModule
  ]
})
export class NotFoundComponent {

}
